import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'views/FormComponents';
import { Row, Columns } from 'views/Grid';

class PostfixedInput extends React.Component {
  render () {
    const { postfix, ...others } = this.props;
    return (
      <Row className="collapse postfix-radius">
        <Columns className="small-10">
          {
            others.type === 'number'
            ? <InputNumber {...others} />
            : <input {...others} />
          }
        </Columns>
        <Columns className="small-2">
          <span className="postfix">{postfix}</span>
        </Columns>
      </Row>
    );
  }
}

PostfixedInput.propTypes = {
  postfix: PropTypes.any.isRequired,
};

export default PostfixedInput;



// WEBPACK FOOTER //
// ./src/common/views/form/PostfixedInput.js